import { render, staticRenderFns } from "./BusinessAdd.vue?vue&type=template&id=1f3bde66"
import script from "./BusinessAdd.vue?vue&type=script&lang=js"
export * from "./BusinessAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports